import React from 'react';
import { Card, CardContent, Typography, Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { EmojiEvents } from '@mui/icons-material';

interface Award {
  awardTitle?: string;
  title?: string;
  issuer?: string;
  awardDate?: string;
  date?: string;
  description?: string;
}

interface ProfileAwardsProps {
  awards?: Award[];
}

export default function ProfileAwards({ awards }: ProfileAwardsProps) {
  if (!awards || awards.length === 0) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <EmojiEvents sx={{ mr: 1 }} />
          <Typography variant="h6">Awards & Achievements</Typography>
        </Box>
        <List>
          {awards.map((award: Award, index: number) => (
            <ListItem key={index}>
              <ListItemIcon>
                <EmojiEvents color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={award.awardTitle || award.title || 'Award'}
                secondary={
                  <Box component="span">
                    {award.issuer || ''} 
                    {(award.awardDate || award.date) ? ` • ${award.awardDate || award.date}` : ''}
                    {award.description && (
                      <Box component="span" sx={{ display: 'block', mt: 0.5, fontStyle: 'italic' }}>
                        {award.description}
                      </Box>
                    )}
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}